import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDatasets = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.47692 16C3.96 16 3.70154 16 3.504 15.8823C3.33016 15.7784 3.18883 15.6125 3.10031 15.4085C3 15.1774 3 14.8741 3 14.2667L3 4.73333C3 4.12667 3 3.82333 3.10031 3.5915C3.18894 3.38775 3.33025 3.22215 3.504 3.11844C3.70092 3 3.95938 3 4.47692 3L9.52308 3C10.04 3 10.2985 3 10.496 3.11772C10.6696 3.22174 10.8107 3.38759 10.8991 3.5915C11 3.82261 11 4.12594 11 4.73333L11 14.2667C11 14.8733 11 15.1767 10.8991 15.4085C10.8107 15.6124 10.6696 15.7783 10.496 15.8823C10.2991 16 10.0406 16 9.52308 16L4.47692 16Z",
			fill: "currentColor",
			fillOpacity: .2
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.47692 19C8.96 19 8.70154 19 8.504 18.8823C8.33016 18.7784 8.18883 18.6125 8.10031 18.4085C8 18.1774 8 17.8741 8 17.2667L8 7.73333C8 7.12667 8 6.82333 8.10031 6.5915C8.18894 6.38775 8.33025 6.22215 8.504 6.11844C8.70092 6 8.95938 6 9.47692 6L14.5231 6C15.04 6 15.2985 6 15.496 6.11772C15.6696 6.22174 15.8107 6.38759 15.8991 6.5915C16 6.82261 16 7.12594 16 7.73333L16 17.2667C16 17.8733 16 18.1767 15.8991 18.4085C15.8107 18.6124 15.6696 18.7783 15.496 18.8823C15.2991 19 15.0406 19 14.5231 19L9.47692 19Z",
			fill: "currentColor",
			fillOpacity: .4
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.4769 22C13.96 22 13.7015 22 13.504 21.8823C13.3302 21.7784 13.1888 21.6125 13.1003 21.4085C13 21.1774 13 20.8741 13 20.2667L13 10.7333C13 10.1267 13 9.82333 13.1003 9.5915C13.1889 9.38775 13.3303 9.22215 13.504 9.11844C13.7009 9 13.9594 9 14.4769 9L19.5231 9C20.04 9 20.2985 9 20.496 9.11772C20.6696 9.22174 20.8107 9.38759 20.8991 9.5915C21 9.82261 21 10.1259 21 10.7333L21 20.2667C21 20.8733 21 21.1767 20.8991 21.4085C20.8107 21.6124 20.6696 21.7783 20.496 21.8823C20.2991 22 20.0406 22 19.5231 22L14.4769 22Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgDatasets);
export { ForwardRef as ReactComponent };
